"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileProtocolV1Constants = void 0;
var FileProtocolV1Constants;
(function (FileProtocolV1Constants) {
    FileProtocolV1Constants[FileProtocolV1Constants["KeySize"] = 256] = "KeySize";
})(FileProtocolV1Constants || (exports.FileProtocolV1Constants = FileProtocolV1Constants = {}));
